<template dir="rtl">
  <!--  <splash></splash>-->
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between">
              <h2 style="font-size: 1.2vw !important; text-align: right">ارزیابی نیازها و انتظارات ذی نفعان </h2>
              <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
            </div>
            <hr class="mb-3">
            <main class="">
              <div v-if="!status"
                   class="card bg-white p-3 shadow d-flex flex-column align-items-center justify-content-center">
                <p style="font-size: 1vw !important">
                  در حال حاضر شما هیچ سوالی در پرسشنامه ندارید ، برای ساخت اولین پرسشنامه دکمه انتشار را فشار دهید!
                </p>
                <button @click.prevent="is_release=true" v-if="!is_release" class="btn btn-submit-1 btn-primary">انتشار
                  پرسشنامه
                </button>
                <div v-else class="d-flex">
                  <button class="btn btn-submit-1 mx-2 btn-primary bg-danger border-danger"
                          @click.prevent="is_release=false">لغو
                  </button>
                  <button @click.prevent="releaseMethod" class="btn btn-submit-1 btn-primary">تایید</button>

                </div>
              </div>

              <div v-if="loader" class="d-flex flex-column align-items-center justify-content-center">
                <div class="bg__create"></div>
                <p class="fw-bold" style="font-size: 1vw !important">
                  در حال انتشار سوالات پرسشنامه...
                </p>
              </div>
              <section v-if="all_items.length" class="px-4">
                <div

                    data-aos="fade-up"
                    class="mb-4 rounded-8vw col-lg-12 mr-auto pb-3 bg-white rounded"
                >
                  <div class="d-flex gap-2-2vw mx-0 align-items-start p-4">
                    <form class="col-8 flex-grow-1 flex-shrink-0 z-10 flex-row border rounded p-3">
                      <div class="d-flex flex-row gap-4vw">
                        <div class="d-flex flex-column w-100 gap-1vw align-items-center justify-content-center">
                          <div class="row mx-0 w-100 align-items-center">
                            <label class="col-7 px-0 fs-1-2vw text-white fw-bold d-flex">
                            </label>
                            <div class="col-1"></div>
                            <div
                                style="width: 12vw"
                                class="d-flex px-0 align-items-center justify-content-between gap-1 border-b-info-3 text-center radioLabel pb-3 text-info"
                            >
                              <p class="mb-0">خیلی ضعیف</p>
                              <p class="mb-0"><br />ضعیف</p>
                              <p class="mb-0"><br>متوسط</p>
                              <p class="mb-0"><br />خوب</p>
                              <p class="mb-0">خیلی خوب</p>
                            </div>
                          </div>
                          <div        v-for="(item,index) in all_items"
                                      :key="item.id" class="row mx-0 w-100 align-items-center">
                            <label class="col-7 px-0 fs-1-2vw text-dark fw-bold">
                              <edit @click.prevent="editMethod(item.title,item.id)" style="width: 1vw; cursor: pointer" />
                             {{index+1}} - {{ item.title }}
                            </label>
                            <div class="col-1"></div>
                            <div
                                style="width: 12vw"
                                class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                            >
                              <p class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw">
                                خیلی ضعیف
                              </p>
                              <div class="flex-grow-1">
                                <div
                                    class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                                >
                                  <div
                                      v-for="(n, index) in 5"
                                      :key="index"
                                      :class="{ active: item.selectedOption === n }"
                                      class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                                  >
                                    <input
                                        :value="n"
                                        v-model="item.selectedOption"
                                        @change="updateChartData(item.id, index + 1)"
                                        type="radio"
                                        :name="'radio' + item.id"
                                        class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                                    />
                                    {{ n }}
                                  </div>
                                </div>
                              </div>
                              <p class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw">
                                خیلی خوب
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <center class="p-2">
                    <hr class="mt-2 mb-2" />
                    <button @click="showData" class="btn btn-primary py-3 btn-submit-1 x mt-4">
                      ذخیره
                    </button>
                  </center>
                </div>
              </section>
            </main>


          </div>
        </div>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error" v-show="statusEdit">
    <div>
      <p style="font-size: 1vw !important">ویرایش</p>
      <p @click="statusEdit=!statusEdit">❌</p>
    </div>
    <div>
      <input type="text" v-model="title" class="form-control">
      <button @click="update(id)">ویرایش</button>
    </div>
  </div>
</template>


<script>
import {useToast} from "vue-toastification";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Splash from "@/components/Splash/SplashWait.vue";
import Edit from "@/components/Icons/Edit.vue";

const toast = useToast();

export default {
  components: {Edit, Splash, Sidebar},
  data() {
    return {
      is_release: false,
      status: false,
      loader: false,
      statusEdit: false,
      title: '',
      id: '',
      all_items: [],
    }
  },
  methods: {
    updateChartData(id, value) {
      // Find the item by id and update the selected option
      const item = this.all_items.find((item) => item.id === id);
      if (item) {
        item.selectedOption = value;
      }
      // Update your chart data or any other logic here
    },
    releaseMethod() {
      this.is_release = false
      this.status = true
      this.loader = true
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(`${this.base_url}/StakeholderEvaluationQuestionnaire/store`, requestOptions)
          .then((response) => response.json())
          .then((response) => {

            setTimeout(() => {
              this.loader = false
              if (response.all) {
                this.all_items = response.all
              }
            }, 5000)
          })
          .catch((error) => console.error(error));


    },
    all() {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(`${this.base_url}/StakeholderEvaluationQuestionnaire`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.status = response.status
            }
            if (response.all) {
              this.all_items = response.all
            }
          })
          .catch((error) => console.error(error));
    },
    editMethod(title,id) {
      this.title = title
      this.id = id
      this.statusEdit = true
    },
    update(id){

      const myHeaders = new Headers();
      const formData = new FormData();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      formData.append('title', this.title)
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow"
      };

      fetch(`${this.base_url}/StakeholderEvaluationQuestionnaire/update/${id}`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return;
            }

            if (response.message){
              this.statusEdit=false
              this.all()
              toast.success(response.message)
            }
          })
          .catch((error) => console.error(error));



    },


  },

  mounted() {
    this.all()
  }
};
</script>
<style lang="scss" scoped>
p {
  font-size: 0.7vw !important;
}

label {
  text-align: right;
  font-size: 0.9vw !important;
}

input {
  z-index: 999999999999999999999999999999999999999999 !important;
}

.inputBox {
  width: 12vw !important;
}

.radioLabel p:last-child::before {
  left: 0.9vw;
  right: auto;
  bottom: -1.1vw !important;
}

.radioLabel p:nth-child(4) {
  right: 0.2vw !important;
}

.radioLabel p:nth-child(3) {
  right: -0.3vw !important;

}

.radioLabel p:nth-child(2) {
  right: -0.7vw !important;

}

.radioLabel p:nth-child(1) {
  //top: -0.5vw !important;

}

.radioLabel p:first-child::before, .radioLabel p:nth-child(3)::before {
  left: auto;
  bottom: -1.2vw;
}

img:hover {
  filter: unset !important;

}

.bg__create {
  background-image: url('../../assets/gifs/convert.gif');
  background-position: center;
  background-repeat: no-repeat;
  width: 15vw;
  height: 15vw;
  background-size: contain;
}


</style>
